package org.braunequip.web.components.forms

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Resize
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.layout.HorizontalDivider
import com.varabyte.kobweb.silk.components.text.SpanText
import kotlinx.browser.document
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.braunequip.web.components.models.DieselType
import org.braunequip.web.components.models.EquipRepairRequestDTO
import org.braunequip.web.util.Constants.FONT_FAMILY
import org.braunequip.web.util.Constants.FONT_FAMILY2
import org.braunequip.web.util.InputIDs
import org.braunequip.web.util.Theme
import org.braunequip.web.util.submitEquipRepairForm
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.name
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.*
import org.w3c.dom.HTMLInputElement
import org.w3c.dom.HTMLTextAreaElement

@Composable
fun EquipmentRepairRequestForm(
    scope: CoroutineScope,
    onFinish: () -> Unit
) {
    var errorText by remember { mutableStateOf(" ") }
    var equipRepairFormState by remember { mutableStateOf(EquipRepairRequestDTO()) }

    H3(Modifier.classNames("title", "is-3", "has-text-dark").toAttrs()) {
        Text("Equipment Repair Request Form")
    }

    Row(
        modifier = Modifier
            .fillMaxWidth()
            .gap(20.px)
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
        ) {
            SpanText(
                text = "Name*",
                modifier = Modifier
                    .margin(right = 10.px)
                    .fontWeight(FontWeight.Bold)
            )

            Row(
                modifier = Modifier
                    .gap(20.px)
            ) {
                Input(
                    type = InputType.Text,
                    attrs = Modifier
                        .id(InputIDs.EquipRepairForm.firstname)
                        .fillMaxWidth()
                        .height(54.px)
                        .margin(topBottom = 12.px)
                        .padding(leftRight = 20.px)
                        .backgroundColor(Theme.LightGray.rgb)
                        .borderRadius(r = 4.px)
                        .border(
                            width = 1.px,
                            style = LineStyle.Solid,
                            color = Colors.Black
                        )
                        .fontFamily(FONT_FAMILY)
                        .fontSize(16.px)
                        .toAttrs {
                            attr("placeholder", "First Name")
                        }
                )

                Input(
                    type = InputType.Text,
                    attrs = Modifier
                        .id(InputIDs.EquipRepairForm.lastname)
                        .fillMaxWidth()
                        .height(54.px)
                        .margin(topBottom = 12.px)
                        .padding(leftRight = 20.px)
                        .backgroundColor(Theme.LightGray.rgb)
                        .borderRadius(r = 4.px)
                        .border(
                            width = 1.px,
                            style = LineStyle.Solid,
                            color = Colors.Black
                        )
                        .fontFamily(FONT_FAMILY)
                        .fontSize(16.px)
                        .toAttrs {
                            attr("placeholder", "Last Name")
                        }
                )
            }

        }


    }

    Row(
        modifier = Modifier
            .fillMaxWidth(),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
        ) {
            SpanText(
                text = "Date*",
                modifier = Modifier
                    .margin(right = 10.px)
                    .fontWeight(FontWeight.Bold)
            )

            Input(
                type = InputType.Date,
                attrs = Modifier
                    .id(InputIDs.EquipRepairForm.date)
                    .fillMaxWidth()
                    .height(54.px)
                    .margin(topBottom = 12.px)
                    .padding(leftRight = 20.px)
                    .backgroundColor(Theme.LightGray.rgb)
                    .borderRadius(r = 4.px)
                    .border(
                        width = 1.px,
                        style = LineStyle.Solid,
                        color = Colors.Black
                    )
                    .fontFamily(FONT_FAMILY2)
                    .fontSize(16.px)
                    .toAttrs()
            )
        }
    }

    HorizontalDivider(modifier = Modifier.fillMaxWidth().margin(topBottom = 1.cssRem))

    Row(
        modifier = Modifier
            .fillMaxWidth()
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
        ) {
            SpanText(
                text = "Tractor Unit #*",
                modifier = Modifier
                    .margin(right = 10.px)
                    .fontWeight(FontWeight.Bold)
            )

            Input(
                type = InputType.Text,
                attrs = Modifier
                    .id(InputIDs.EquipRepairForm.tractorUnit)
                    .fillMaxWidth()
                    .height(54.px)
                    .margin(topBottom = 12.px)
                    .padding(leftRight = 20.px)
                    .backgroundColor(Theme.LightGray.rgb)
                    .borderRadius(r = 4.px)
                    .border(
                        width = 1.px,
                        style = LineStyle.Solid,
                        color = Colors.Black
                    )
                    .fontFamily(FONT_FAMILY)
                    .fontSize(16.px)
                    .toAttrs {
                        attr("placeholder", "")
                    }
            )

        }
    }

    Row(
        modifier = Modifier
            .fillMaxWidth()
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
        ) {
            SpanText(
                text = "Explain Tractor Repairs Needed*",
                modifier = Modifier
                    .margin(right = 10.px)
                    .fontWeight(FontWeight.Bold)
            )

            TextArea(
                attrs = Modifier
                    .id(InputIDs.EquipRepairForm.tractorNeeds)
                    .fillMaxWidth()
                    .height(175.px)
                    .maxHeight(400.px)
                    .margin(top = 8.px)
                    .padding(all = 20.px)
                    .backgroundColor(Theme.LightGray.rgb)
                    .borderRadius(4.px)
                    .fontFamily(FONT_FAMILY)
                    .fontSize(16.px)
                    .border(
                        width = 1.px,
                        style = LineStyle.Solid,
                        color = Colors.Black
                    )
                    .resize(Resize.None)
                    .toAttrs{
                        attr("placeholder", "As Detailed as possible")
                    }
            )
        }
    }

    Row(
        modifier = Modifier
            .margin(topBottom = 12.px)
            .fillMaxWidth()
            .gap(20.px)
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
        ) {
            SpanText(
                text = "Out Of Service?",
                modifier = Modifier
                    .margin(right = 10.px)
                    .fontWeight(FontWeight.Bold)
            )


            Row(
                modifier = Modifier
                    .fillMaxWidth(),
                horizontalArrangement = Arrangement.Start,
                verticalAlignment = Alignment.CenterVertically
            )  {
                Input(
                    type = InputType.Radio,
                    attrs = Modifier
                        .id(InputIDs.EquipRepairForm.tractorOutNo)
                        .margin(right = 15.px)
                        .height(20.px)
                        .border(
                            width = 1.px,
                            style = LineStyle.Solid,
                            color = Colors.Black
                        )
                        .toAttrs {
                            attr("placeholder", "")
                            name(InputIDs.EquipRepairForm.tractorOut)
                            value("false")
                            checked(true)
                        }
                )

                Label(
                    forId = InputIDs.EquipRepairForm.tractorOutNo,
                    attrs = Modifier
                        .fontFamily(FONT_FAMILY2)
                        .fontSize(16.px)
                        .toAttrs()
                ) {
                    Text("No")
                }
            }

            Row(
                modifier = Modifier
                    .fillMaxWidth(),
                horizontalArrangement = Arrangement.Start,
                verticalAlignment = Alignment.CenterVertically
            )  {
                Input(
                    type = InputType.Radio,
                    attrs = Modifier
                        .id(InputIDs.EquipRepairForm.tractorOutYes)
                        .margin(right = 15.px)
                        .height(20.px)
                        .border(
                            width = 1.px,
                            style = LineStyle.Solid,
                            color = Colors.Black
                        )

                        .toAttrs {
                            attr("placeholder", "")
                            name(InputIDs.EquipRepairForm.tractorOut)
                            value("true")
                        }
                )

                Label(
                    forId = InputIDs.EquipRepairForm.tractorOutYes,
                    attrs = Modifier
                        .fontFamily(FONT_FAMILY2)
                        .fontSize(16.px)
                        .toAttrs()
                ) {
                    Text("Yes")
                }
            }
        }
    }

    HorizontalDivider(modifier = Modifier.fillMaxWidth().margin(topBottom = 1.cssRem))

    Row(
        modifier = Modifier
            .fillMaxWidth()
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
        ) {
            SpanText(
                text = "Trailer Unit #*",
                modifier = Modifier
                    .margin(right = 10.px)
                    .fontWeight(FontWeight.Bold)
            )

            Input(
                type = InputType.Text,
                attrs = Modifier
                    .id(InputIDs.EquipRepairForm.trailerUnit)
                    .fillMaxWidth()
                    .height(54.px)
                    .margin(topBottom = 12.px)
                    .padding(leftRight = 20.px)
                    .backgroundColor(Theme.LightGray.rgb)
                    .borderRadius(r = 4.px)
                    .border(
                        width = 1.px,
                        style = LineStyle.Solid,
                        color = Colors.Black
                    )
                    .fontFamily(FONT_FAMILY)
                    .fontSize(16.px)
                    .toAttrs {
                        attr("placeholder", "")
                    }
            )

        }
    }

    Row(
        modifier = Modifier
            .fillMaxWidth()
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
        ) {
            SpanText(
                text = "Explain Trailer Repairs Needed*",
                modifier = Modifier
                    .margin(right = 10.px)
                    .fontWeight(FontWeight.Bold)
            )

            TextArea(
                attrs = Modifier
                    .id(InputIDs.EquipRepairForm.trailerNeeds)
                    .fillMaxWidth()
                    .height(175.px)
                    .maxHeight(400.px)
                    .margin(top = 8.px)
                    .padding(all = 20.px)
                    .backgroundColor(Theme.LightGray.rgb)
                    .borderRadius(4.px)
                    .fontFamily(FONT_FAMILY)
                    .fontSize(16.px)
                    .border(
                        width = 1.px,
                        style = LineStyle.Solid,
                        color = Colors.Black
                    )
                    .resize(Resize.None)
                    .toAttrs{
                        attr("placeholder", "As Detailed as possible")
                    }
            )
        }
    }

    Row(
        modifier = Modifier
            .margin(topBottom = 12.px)
            .fillMaxWidth()
            .gap(20.px)
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
        ) {
            SpanText(
                text = "Out Of Service?",
                modifier = Modifier
                    .margin(right = 10.px)
                    .fontWeight(FontWeight.Bold)
            )


            Row(
                modifier = Modifier
                    .fillMaxWidth(),
                horizontalArrangement = Arrangement.Start,
                verticalAlignment = Alignment.CenterVertically
            )  {
                Input(
                    type = InputType.Radio,
                    attrs = Modifier
                        .id(InputIDs.EquipRepairForm.trailerOutNo)
                        .margin(right = 15.px)
                        .height(20.px)
                        .border(
                            width = 1.px,
                            style = LineStyle.Solid,
                            color = Colors.Black
                        )
                        .toAttrs {
                            attr("placeholder", "")
                            name(InputIDs.EquipRepairForm.trailerOut)
                            value("false")
                            checked(true)
                        }
                )

                Label(
                    forId = InputIDs.EquipRepairForm.trailerOutNo,
                    attrs = Modifier
                        .fontFamily(FONT_FAMILY2)
                        .fontSize(16.px)
                        .toAttrs()
                ) {
                    Text("No")
                }
            }

            Row(
                modifier = Modifier
                    .fillMaxWidth(),
                horizontalArrangement = Arrangement.Start,
                verticalAlignment = Alignment.CenterVertically
            )  {
                Input(
                    type = InputType.Radio,
                    attrs = Modifier
                        .id(InputIDs.EquipRepairForm.trailerOutYes)
                        .margin(right = 15.px)
                        .height(20.px)
                        .border(
                            width = 1.px,
                            style = LineStyle.Solid,
                            color = Colors.Black
                        )

                        .toAttrs {
                            attr("placeholder", "")
                            name(InputIDs.EquipRepairForm.trailerOut)
                            value("true")
                        }
                )

                Label(
                    forId = InputIDs.EquipRepairForm.trailerOutYes,
                    attrs = Modifier
                        .fontFamily(FONT_FAMILY2)
                        .fontSize(16.px)
                        .toAttrs()
                ) {
                    Text("Yes")
                }
            }
        }
    }

    SpanText(
        modifier = Modifier
            .width(350.px)
            .margin(top = 1.cssRem)
            .fontFamily(FONT_FAMILY2)
            .color(Colors.Black)
            .textAlign(TextAlign.Center),
        text = errorText
    )


    SubmitButton(
        text = "SUBMIT",
        onClick = {
            equipRepairFormState = equipRepairFormState.copy(
                firstName = (document.getElementById(InputIDs.EquipRepairForm.firstname) as HTMLInputElement).value,
                lastName = (document.getElementById(InputIDs.EquipRepairForm.lastname) as HTMLInputElement).value,
                date = (document.getElementById(InputIDs.EquipRepairForm.date) as HTMLInputElement).value,
                tractorUnit = (document.getElementById(InputIDs.EquipRepairForm.tractorUnit) as HTMLInputElement).value,
                tractorNeeds = (document.getElementById(InputIDs.EquipRepairForm.tractorNeeds) as HTMLTextAreaElement).value,
                tractorService = (document.querySelector("input[name='equiprepairtractorout']:checked") as HTMLInputElement).value.toBoolean(),
                trailerUnit = (document.getElementById(InputIDs.EquipRepairForm.trailerUnit) as HTMLInputElement).value,
                trailerNeeds = (document.getElementById(InputIDs.EquipRepairForm.trailerNeeds) as HTMLTextAreaElement).value,
                trailerService = (document.querySelector("input[name='equiprepairtrailerout']:checked") as HTMLInputElement).value.toBoolean(),
            )

            if (
                equipRepairFormState.firstName.isNotEmpty() &&
                equipRepairFormState.lastName.isNotEmpty() &&
                equipRepairFormState.date.isNotEmpty()
            ) {
                errorText = " "
                scope.launch {
                    submitEquipRepairForm(
                        equipRepairFormState,
                    ) { finishText ->
                        errorText = finishText
                    }
                    delay(1000)
                    onFinish()
                }
            } else {
                errorText = "Please fill out all required fields."
            }

        }
    )



}